import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary to-purple-800 text-white py-20 lg:py-32">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-6">
            <Icon name="MessageCircle" size={32} className="text-white" />
          </div>
          <h1 className="text-4xl lg:text-6xl font-bold mb-6 text-shadow">
            Connection Center
          </h1>
          <p className="text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Your gateway to joining our community of young leaders making a difference in Colombo
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
              <Icon name="Clock" size={20} />
              <span>Quick Response</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
              <Icon name="Users" size={20} />
              <span>Multiple Channels</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
              <Icon name="Calendar" size={20} />
              <span>Meeting Info</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;